document.documentElement.classList.add('js');
document.addEventListener('keydown', event => {
  if (event.key !== 'Tab' || event.defaultPrevented) return;
  const dialog = event.target.closest('dialog[open]');
  if (!dialog) return;
  const items = [...dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')].filter(el => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length);
  const first = items[0], last = items.at(-1);
  if (event.shiftKey && event.target === first) { event.preventDefault(); last.focus(); }
  else if (!event.shiftKey && event.target === last) { event.preventDefault(); first.focus(); }
});
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
  if (!button) return;
  const input = button.closest('.qty-stepper')?.querySelector('input[type="number"]');
  if (!input) return;
  if (input.disabled) return;
  if (!input.value || !Number.isFinite(Number(input.value))) input.value = input.min || '1';
  if (button.hasAttribute('data-quantity-plus')) input.stepUp(); else input.stepDown();
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-brand-filter]');
  if (!button) return;
  const showcase = button.closest('[data-brand-showcase]');
  const filter = button.dataset.brandFilter;
  showcase.querySelectorAll('[data-brand-filter]').forEach((item) => {
    item.classList.toggle('is-active', item === button);
    item.setAttribute('aria-pressed', String(item === button));
  });
  // Exact tag match: each card lists the tabs it belongs to (client brand grouping, one list per tab).
  showcase.querySelectorAll('[data-brand-card]').forEach((card) => {
    card.hidden = !card.dataset.brandTags.split(',').includes(filter);
  });
});
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-scroll-products]');
  if (!button) return;
  const scroller = button.closest('.most-ordered')?.querySelector('[data-product-scroller]');
  if (!scroller) return;
  scroller.scrollBy({ left: (button.dataset.scrollProducts === 'next' ? 1 : -1) * scroller.clientWidth, behavior: 'smooth' });
});

const footerColumns = document.querySelectorAll('.site-footer__column');
const desktopFooter = window.matchMedia('(min-width: 48rem)');
const syncFooterColumns = () => footerColumns.forEach((column) => { column.open = desktopFooter.matches; });
syncFooterColumns();
desktopFooter.addEventListener('change', syncFooterColumns);

// Click-and-drag scrolling for horizontal carousels on mouse devices. Touch devices already swipe natively.
(() => {
  const selector = '[data-product-scroller], [data-reviews-track]';
  let active = null;
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const scroller = event.target.closest(selector);
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;
    if (event.target.closest('button, input, select, textarea, label')) return;
    active = { scroller, startX: event.clientX, startLeft: scroller.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', (event) => {
    if (!active) return;
    const delta = event.clientX - active.startX;
    if (!active.moved && Math.abs(delta) < 6) return;
    if (!active.moved) {
      active.moved = true;
      active.snap = active.scroller.style.scrollSnapType;
      active.scroller.style.scrollSnapType = 'none';
      active.scroller.classList.add('is-dragging');
    }
    active.scroller.scrollLeft = active.startLeft - delta;
    event.preventDefault();
  });
  const end = () => {
    if (!active) return;
    const { scroller, moved, snap } = active;
    if (moved) {
      scroller.classList.remove('is-dragging');
      const left = scroller.scrollLeft;
      scroller.style.scrollSnapType = snap || '';
      scroller.scrollLeft = left;
      // Swallow the click that follows a drag so a card link is not opened by accident.
      scroller.addEventListener('click', (click) => { click.preventDefault(); click.stopPropagation(); }, { capture: true, once: true });
    }
    active = null;
  };
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  document.addEventListener('dragstart', (event) => { if (event.target.closest(selector)) event.preventDefault(); });
})();
